import { Action } from '@ngrx/store';
import { RecommendationTemplateInterface, RecommendationTemplateRuleInterface } from 'app/recommendation/models';
import { RecommendationCategoryInterface } from 'app/recommendation/models/recommendation-category.model';
import { RecommendationInterface } from 'app/recommendation/models/recommendation.model';

import { RecommendationActionType } from './recommendation-action-type.enum';


export class UpdateEmployeeRecommendation implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.UpdateEmployeeRecommendation;

  constructor(public readonly payload: RecommendationInterface) { }
}

export class UpdateEmployeeRecommendationCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.UpdateEmployeeRecommendationCompleted;

  constructor(public readonly payload: RecommendationInterface) { }
}

export class UpdateEmployeeRecommendationFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.UpdateEmployeeRecommendationFailed;

  constructor(public readonly payload: string) { }
}

export class UpdateRecommendationTemplate implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.UpdateRecommendationTemplate;

  constructor(public readonly payload: RecommendationTemplateInterface) { }
}

export class UpdateRecommendationTemplateCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.UpdateRecommendationTemplateCompleted;

  constructor(public readonly payload: RecommendationTemplateInterface) { }
}

export class UpdateRecommendationTemplateFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.UpdateRecommendationTemplateFailed;

  constructor(public readonly payload: string) { }
}

export class UpdateRecommendationCategory implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.UpdateRecommendationCategory;

  constructor(public readonly payload: RecommendationCategoryInterface) { }
}

export class UpdateRecommendationCategoryCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.UpdateRecommendationCategoryCompleted;

  constructor(public readonly payload: RecommendationCategoryInterface) { }
}

export class UpdateRecommendationCategoryFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.UpdateRecommendationCategoryFailed;

  constructor(public readonly payload: string) { }
}

export class UpdateRecommendationTemplateRule implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.UpdateRecommendationTemplateRule;

  constructor(public readonly payload: {recommendation: RecommendationInterface, rule: RecommendationTemplateRuleInterface}) { }
}

export class UpdateRecommendationTemplateRuleCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.UpdateRecommendationTemplateRuleCompleted;

  constructor(public readonly payload: RecommendationTemplateInterface) { }
}

export class UpdateRecommendationTemplateRuleFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.UpdateRecommendationTemplateRuleFailed;

  constructor(public readonly payload: string) { }
}
